import { SelectInput } from '@interstate/components/SelectInput';
import type { DealTabs } from '@makemydeal/dr-shared-types';
import { useFlexBuyPercentField } from './hooks/useFlexBuyPercentField';

export const FlexBuyPercentSelectInput = ({ tab }: { tab?: DealTabs }) => {
    const { label, selectProps } = useFlexBuyPercentField({ tab });

    return <SelectInput id="flex-buy-percentage" label={label} {...selectProps} />;
};
